import { render, staticRenderFns } from "./ConfigRoleMumbersDialog.vue?vue&type=template&id=4d685d0f&scoped=true"
import script from "./ConfigRoleMumbersDialog.vue?vue&type=script&lang=ts"
export * from "./ConfigRoleMumbersDialog.vue?vue&type=script&lang=ts"
import style0 from "./ConfigRoleMumbersDialog.vue?vue&type=style&index=0&id=4d685d0f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d685d0f",
  null
  
)

export default component.exports